import { put, call, all, takeEvery, takeLeading, delay, select } from "redux-saga/effects";
import authActions from "./actions";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import commonActions from "../common/actions";
import Cookies from 'js-cookie';
import setAuthToken from "../../utils/setAuthToken";
import { rememberVerificationUrl } from "../../utils/returnUrl";

const authSagas = function* () {
    yield all([
        yield takeEvery(authActions.AUTH_LOGIN, authLogin),
        yield takeEvery(authActions.BACKOFFICE_TOKEN_VERIFY, backofficeVerifyToken),
        yield takeEvery(authActions.BACKOFFICE_FORGET_PASSWORD, backofficeForgetPassword),
        // Leading only: RoleSelection can fire this several times as the token
        // details refresh; concurrent duplicates would race the first one and
        // navigate away from the saved return link (e.g. a scanned QR).
        yield takeLeading(authActions.ROLE_TOKEN_GENERATION, roleTokenGeneration),
    ])
};

const authLogin = function* (data) {
    const { payload } = data;
    const { navigate } = payload;

    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
    try {
        const result = yield call(() =>
            axios.post(`${API_URL}/backoffice/login`, payload?.data)
        );
        yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
        yield put({
            type: commonActions.SET_ALERT,
            payload: {
                status: (result?.data?.statusCode === 200) ? 'success' : 'failed',
                show: true,
                message: result?.data?.message
            }
        });
        if (result?.data?.statusCode === 200) {
            navigate(`/${Cookies.get('mhet_mst_project')}/role-selection`);
            Cookies.set('mhet_mst_temptoken', result?.data?.token, { expires: 7 })
            Cookies.set('mhet_mst_userid', result?.data?.result?.id);
            // navigate(`/${Cookies.get('mhet_mst_project')}/home`);
            // Cookies.set('mhet_mst_token', result?.data?.token, { expires: 7 });
            // setAuthToken(result?.data?.token);
            yield put({ type: authActions.BACKOFFICE_TOKEN_VERIFY });
        };
        yield delay(2000);
        yield put({
            type: commonActions.SET_ALERT,
            payload: { status: null, show: false, message: null }
        });
    } catch (err) {
         ;
        Cookies.remove('mhet_mst_token');
        Cookies.remove('mhet_mst_userid');
        window.location.href = `/${Cookies.get('mhet_mst_project')}/userlogin`;
    };
};
const backofficeForgetPassword = function* (data) {
    const { payload } = data;
    const { navigate } = payload;

    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
    try {
        const result = yield call(() =>
            axios.post(`${API_URL}/backoffice/reset-password`, payload?.data)
        );
        yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
        yield put({
            type: commonActions.SET_ALERT,
            payload: {
                status: (result?.data?.statusCode === 200) ? 'success' : 'failed',
                show: true,
                message: result?.data?.message
            }
        });
        if (result?.data?.statusCode === 200) {
            navigate(`/${Cookies.get('mhet_mst_project')}/home`);
        };
        yield delay(2000);
        yield put({
            type: commonActions.SET_ALERT,
            payload: { status: null, show: false, message: null }
        });
    } catch (err) {
         ;
        Cookies.remove('mhet_mst_token');
        Cookies.remove('mhet_mst_userid');
        window.location.href = `/${Cookies.get('mhet_mst_project')}/userlogin`;
    };
};

const backofficeVerifyToken = function* () {

    try {
        const { backofficeTokenDetails } = yield select(state => state.authReducer);
        if (!backofficeTokenDetails) {
            const result = yield call(() =>
                axios.get(`${API_URL}/backoffice/verify-token`, {
                    headers: {
                        authorization: `Bearer ${Cookies.get('mhet_mst_temptoken') || Cookies.get('mhet_mst_token')}`
                    }
                })
            );
            if (result?.data?.statusCode === 200) {
                yield put({ type: authActions.SET_BACKOFFICE_TOKEN_DETAILS, payload: result?.data?.result });
            } else {
                rememberVerificationUrl();
                Cookies.remove('mhet_mst_token');
                Cookies.remove('mhet_mst_userid');
                window.location.href = `/${Cookies.get('mhet_mst_project')}/userlogin`;
            };
        }
    } catch (err) {
         ;
        rememberVerificationUrl();
        Cookies.remove('mhet_mst_token');
        Cookies.remove('mhet_mst_userid');
        window.location.href = `/${Cookies.get('mhet_mst_project')}/userlogin`;
    };
}

const roleTokenGeneration = function* (data) {
    const { payload } = data;
    const { navigate } = payload;

    yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
    try {
        let data = {
            role: payload?.role,
            token: Cookies.get('mhet_mst_temptoken')
        };
        const result = yield call(() =>
            axios.post(`${API_URL}/backoffice/role-token`, data)
        );
        if(result?.data?.statusCode === 200){
            Cookies.remove('mhet_mst_temptoken');
            // Persist the token BEFORE navigating so the guarded route (PrivateRoute)
            // sees an authenticated session and does not bounce back to login.
            Cookies.set('mhet_mst_token', result?.data?.token, { expires: 7 });
            Cookies.set('mhet_mst_userid', result?.data?.result?.id);
            setAuthToken(result?.data?.token);
            // Return to the originally requested page (e.g. a scanned QR link) if any.
            const returnUrl = Cookies.get('mhet_mst_returnurl');
            Cookies.remove('mhet_mst_returnurl');
            navigate(returnUrl || `/${Cookies.get('mhet_mst_project')}/home`);
            window.location.reload();
        };
        yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    } catch (err) {
         ;
    };
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

export default authSagas;